
export default {
  SET_CITIES_LIST(state, payload) {
    state.cities = payload;
  }
};
